import { useState } from "react";
import { resetPassword } from "../../../api";
import { useNavigate } from "react-router-dom";
import { useToast } from "@chakra-ui/react";
import { track, EVENTS } from "../../../utils/analytics";

interface ResetPasswordController {
  email: string;
  formEmailError: string;
  errorMessage: string;
  loading: boolean;
  setEmail: (email: string) => void;
  reset: () => void;
}

export const useResetPasswordController = () => {
  const [email, setEmail] = useState<string>("");
  const [formEmailError, setFormEmailError] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();

  const navigate = useNavigate();

  const performReset = async () => {
    track(EVENTS.AUTH.RESET_ATTEMPT, {
      email: email,
    });

    setLoading(true);
    resetPassword(email)
      .then((res) => {
        if (res.success === true) {
          track(EVENTS.AUTH.RESET_SUCCESS, {
            email: email,
          });

          toast({
            title: "Success",
            description: res.msg,
            status: "success",
            duration: 5000,
            isClosable: true,
          });

          setTimeout(() => {
            navigate("/app/login?reset=true");
          }, 1000);
        } else {
          track(EVENTS.AUTH.RESET_FAILURE, {
            email: email,
            error: res.msg,
          });

          if (res.errors) {
            res.errors.filter((e: any) => {
              if (e.path === "email") {
                setFormEmailError(e.msg);
                toast({
                  title: "Error",
                  description: e.msg,
                  status: "error",
                  duration: 5000,
                  isClosable: true,
                });
              }
            });
          } else {
            setErrorMessage(res.msg);
            toast({
              title: "Error",
              description: res.msg,
              status: "error",
              duration: 5000,
              isClosable: true,
            });
          }
          setLoading(false);
        }
      })
      .catch((e: any) => {
        track(EVENTS.AUTH.RESET_FAILURE, {
          email: email,
          error: e.message,
        });

        console.log("API Call, error call login", e);
        setLoading(false);
      });
  };

  return {
    email,
    setEmail,
    errorMessage,
    loading,
    formEmailError,
    reset: performReset,
  } as ResetPasswordController;
};
